<template>
  <div>
    <section-definition
      :title="page.title"
      :breadcrumbs="breadcrumbs"
    ></section-definition>
    <v-container fluid grid-list-xl page>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <section-header v-text="page.headline"></section-header>
          <div class="my-5"></div>
        </v-flex>
      </v-layout>
      <datatable
        title="Concesionarios"
        :columns="headers"
        :rows="userslist"
        locale="es"
      ></datatable>

      <datatable
        title="Alquileres"
        :columns="headersRents"
        :rows="rentslist"
        locale="en"
        :perPage="[50, 100]"
        :defaultPerPage="100"
      ></datatable>
    </v-container>
  </div>
</template>

<script>
import DataTable from "vue-materialize-datatable";

export default {
  data() {
    return {
      userslist: [],
      rentslist: [],
      machineslist: [],
      page: {
        title: "Exportaciones",
        headline: "Exportaciones",
        description: ""
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Exportacionesk",
          disabled: false
        }
      ],
      headers: [
        { label: "Usuario", field: "useralias" },
        { label: "ID", field: "iduser" },
        { label: "NIF", field: "useridentitydocument" },
        { label: "Nombre", field: "username" },
        { label: "Apellido 1 ", field: "usersurname1" },
        { label: "Apellido 2", field: "usersurname2" },
        { label: "Valoracion", field: "userrateasowner" },
        { label: "Estado", field: "userstatus" },
        { label: "SEPA", field: "sepaallowed" },
        { label: "Movil", field: "userphone" },
        { label: "Fecha creación. ", field: "usercreationdate" },
        { label: "Num. Equipos", field: "nummachines" },
        { label: "Num. Alquileres", field: "numrents" },
        { label: "Importe", field: "amountrents" }
      ],
      headersRents: [
        { label: "Propietario", field: "owneralias" },
        { label: "Arrendatario", field: "useralias" },
        { label: "ID alquiler", field: "idrent" },
        { label: "Equipo ", field: "machinename" },
        { label: "Fecha inicio ", field: "rentfrom" },
        { label: "Fecha fin ", field: "rentto" },
        { label: "Precio (€)", field: "rentprice" },
        { label: "Precio final(€)", field: "rentfinalprice" },
        { label: "Fianza (€)", field: "rentpriceexcess" },
        { label: "Estado", field: "rentstatuslabel" },
        { label: "Fase", field: "rentphase" },
        { label: "Lugar de entrega", field: "rentplace" },
        { label: "Transporte?", field: "transportNeeded" },
        { label: "Precio transporte (€)", field: "transportPrice" }
      ]
    };
  },
  components: {
    datatable: DataTable
  },
  mounted: function() {
    this.loadData();
    this.loadRents();
  },
  methods: {
    loadData() {
      const self = this;
      let url = process.env.VUE_APP_BASE_URI + "/getpremiumlistforcompany";
      self.isLoading = true;
      self.$http.get(url).then(
        function(success) {
          var userlisttemp = success.data.users;
          self._.forEach(userlisttemp, function(currentitem, index) {
            userlisttemp[index].usercreationdate = self
              .moment(currentitem.usercreationdate)
              .format("DD-MM-YYYY")
              .split("T")[0];

            if (currentitem.userstatus === 1) {
              userlisttemp[index].userstatuslabel = "En registro";
            } else if (currentitem.userstatus === 2) {
              userlisttemp[index].userstatuslabel = "Activo ";
            } else {
              userlisttemp[index].userstatuslabel = "---";
            }

            if (currentitem.sepaallowed === 1) {
              userlisttemp[index].sepaallowedlabel = "SI";
            } else {
              userlisttemp[index].sepaallowedlabel = "NO";
            }
          });
          self.userslist = userlisttemp;
          self.isLoading = false;
        },
        function(error) {
          self.isLoading = false;

          self.snacktext = "Error al obtener lista de usuarios";
          self.snackcolor = "error";
          self.snackresult = true;
          /*     self.$toast.open({
                        duration: 5000,
                        message: self.$t('myMachinesErrorGetMachines'),
                        type: 'is-danger'
                    })
                */
        }
      );
    },

    loadRents() {
      const self = this;

      let url = process.env.VUE_APP_BASE_URI + "/getrentsforcompany";
      self.$http.get(url).then(
        function(success) {
          var paymentstemp = success.data.rents;
          var rentsfinal = [];
          self._.forEach(paymentstemp, function(expense, index) {
            if (expense.rentstatus < 10) {
              paymentstemp[index].rentfromcalc = self.moment(expense.rentfrom);
              paymentstemp[index].renttocalc = self.moment(expense.rentto);

              paymentstemp[index].rentfrom = self
                .moment(expense.rentfrom)
                .format("DD-MM-YYYY")
                .split("T")[0];
              paymentstemp[index].rentto = self
                .moment(expense.rentto)
                .format("DD-MM-YYYY")
                .split("T")[0];

              if (expense.rentstatus === 1) {
                paymentstemp[index].rentstatuslabel = "Solicitado";
              }
              if (expense.rentstatus === 2) {
                paymentstemp[index].rentstatuslabel = "Aprobado";
              }
              if (expense.rentstatus >= 3 && expense.rentstatus < 6) {
                paymentstemp[index].rentstatuslabel = "Firmado";
              }
              if (expense.rentstatus === 6) {
                paymentstemp[index].rentstatuslabel = "Entrega";
              }
              if (expense.rentstatus === 7) {
                paymentstemp[index].rentstatuslabel = "Recogida";
              }
              if (expense.rentstatus === 8) {
                paymentstemp[index].rentstatuslabel = "Liquidación";
              }
              if (expense.rentstatus === 9) {
                paymentstemp[index].rentstatuslabel = "Finalizado";
              }

              if (expense.transportNeeded === 1) {
                paymentstemp[index].transportNeededlabel = "SI";
              } else {
                paymentstemp[index].transportNeededlabel = "NO";
              }

              if (expense.rentstatus >= 6 && expense.rentstatus < 9) {
                if (expense.rentphase === 1) {
                  paymentstemp[index].rentphaselabel = "Salida";
                }
                if (expense.rentphase === 2) {
                  paymentstemp[index].rentphaselabel = "Entrega";
                }
                if (expense.rentphase === 3) {
                  paymentstemp[index].rentphaselabel = "Recogida";
                }
                if (expense.rentphase === 4) {
                  paymentstemp[index].rentphaselabel = "Devolución";
                }
              } else {
                paymentstemp[index].rentphaselabel = " ";
              }

              if (expense.idpaymentstatus === 1) {
                paymentstemp[index].stateclass = "state1";
                paymentstemp[index].idpaymentstatus = "PENDIENTE";
              }
              if (expense.idpaymentstatus === 2) {
                paymentstemp[index].stateclass = "state2";
                paymentstemp[index].idpaymentstatus = "PAGADO";
              }
              if (expense.idpaymentstatus === 3) {
                paymentstemp[index].stateclass = "state3";
                paymentstemp[index].idpaymentstatus = "RECHAZADO";
              }

              paymentstemp[index].rentprice = Math.floor(expense.rentprice);
              paymentstemp[index].rentfinalprice = Math.floor(
                expense.rentfinalprice
              );

              rentsfinal.push(paymentstemp[index]);
            }
          });
          self.rentslist = rentsfinal;
        },
        function(error) {
          self.$toast.open({
            duration: 5000,
            message: self.$t("myMachinesErrorGetMachines"),
            type: "is-danger"
          });
        }
      );
    }
  }
};
</script>
